import styled, { css } from 'styled-components';
import { COLORS } from '@global/styles/colors';
import { FONT } from '@global/styles/default';
import { TABLET_800 } from '@global/styles/sizes';
import { IBulletICon } from '@sections/TextColumns/TextColumns.props';

export const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: auto;

  @media (max-width: ${TABLET_800}px) {
    flex-direction: column;
  }
`;
export const FormContainer = styled.div`
  input[type='checkbox'] {
    height: 20px;
    width: 20px !important;
    margin: 6px 0;
  }
  label {
    display: flex;
    font: italic 200 18px/22px ${FONT.montserrat};
    color: ${COLORS.white};
    opacity: 0.9;

    span {
      margin-left: 14px;
      align-self: center;
      font: italic normal normal 18px/28px ${FONT.montserrat};
    }
  }

  option {
    font: italic 200 18px/22px ${FONT.montserrat};
    color: ${COLORS.black};
    opacity: 0.9;
  }

  textarea {
    height: 120px !important;
  }

  input[type='submit'] {
    width: 100%;
    height: 60px;
    border: 2px solid #ffffff;
    border-radius: 3px;
    background: none;
    padding: 10px;
    color: white;
    font: normal normal 400 18px/24px ${FONT.montserrat};
    &:hover {
      border-color: #1acafd;
      transition: background-color 0.2s;
      box-shadow: inset 0px 0px 6px #1acafd, 0px 0px 6px #1acafd;
    }
  }
  select,
  input {
    width: 100% !important;
    background: ${COLORS.white}5f 0% 0% no-repeat padding-box;
    border: none;
    color: white;
    padding: 10px;
    height: 56px;
    margin-top: 6px;
    margin-bottom: 20px;
    opacity: 0.9;
    border-radius: 3px;
    box-sizing: border-box;
    font: normal normal 400 18px/22px ${FONT.montserrat};

    ::placeholder {
      color: ${COLORS.white};
      font: normal italic 400 18px/22px ${FONT.montserrat};
    }
  }
`;
export const TextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: ${TABLET_800}px) {
  }
`;
export const TextContent = styled.div`
  width: 1100px;
  height: 70vh;
  padding: 29px 17%;
  max-width: 90vw;
  box-sizing: border-box;
  background: transparent linear-gradient(90deg, #6717cd 0%, #4645dd 71%, #00a8ff 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 16px;
  position: relative;
  overflow: auto;
  @media (max-width: ${TABLET_800}px) {
    padding: 29px 20px;
  }
`;
export const TitleContainer = styled.div`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;

  @media (max-width: ${TABLET_800}px) {
    margin-bottom: 22px;
  }
`;
export const SubTitle = styled.h3<{ bulletIcon?: IBulletICon }>`
  width: 100%;
  font: normal normal 300 22px/32px ${FONT.montserrat};
  text-align: center;
  margin: 30 auto 0 auto;
  color: ${COLORS.white};

  @media (max-width: ${TABLET_800}px) {
    font: normal normal 300 18px/26px ${FONT.montserrat};
  }

  ul {
    padding: 0;
  }

  p {
    margin-bottom: 24px;
  }

  li {
    font-weight: 300;
    margin: 10px 0;
    font-size: 20px;
    line-height: 26px;
    list-style: none;
    display: flex;

    ::before {
      padding-right: 12px;
      ${({ bulletIcon }) =>
        bulletIcon === IBulletICon.Circle &&
        css`
          content: '●';
        `}
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media (max-width: ${TABLET_800}px) {
    width: 100%;
    margin-top: 20px;
    font: normal normal normal 19px/25px ${FONT.montserrat};
  }

  ${({ bulletIcon }) =>
    bulletIcon &&
    bulletIcon === IBulletICon.Check &&
    `li {

      ::before {
        width: 12px;
        height: 12px;
        display: block;
        padding-right: 12px;
        content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12.627" height="9.416" viewBox="0 0 12.627 9.416"><path id="Icon_awesome-check" data-name="Icon awesome-check" d="M4.289,13.809.185,9.7a.631.631,0,0,1,0-.893l.893-.893a.631.631,0,0,1,.893,0l2.765,2.765,5.921-5.921a.631.631,0,0,1,.893,0l.893.893a.631.631,0,0,1,0,.893L5.182,13.809A.631.631,0,0,1,4.289,13.809Z" transform="translate(0 -4.577)" fill="%23fff"/></svg>');
      }
    }
  `};
`;
export const Line = styled.div`
  width: 30%;
  border-bottom: 4px solid ${COLORS.white};
  margin: 20px 0;
`;
export const Text = styled.div`
  font: normal normal medium 20px/28px ${FONT.montserrat};
  color: ${COLORS.white};
  margin-bottom: 27px;
`;
export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 40px;
  justify-content: space-between;
  @media (max-width: ${TABLET_800}px) {
    flex-direction: column;
  }
`;

export const Title = styled.div`
  text-align: center;
  width: 100%;
  margin-bottom: 26px;
  justify-content: center;
  display: flex;
  font: normal 800 normal 46px/58px ${FONT.montserrat};
  @media (max-width: ${TABLET_800}px) {
    font: normal 800 normal 30px/38px ${FONT.montserrat};
  }
`;
